<template>
    <div>
        <playerList :sport_id="sport_id"></playerList>
    </div>
</template>

<script>

import playerList from '@/components/ballsports/player/list.vue';

export default {
    components: {
        playerList
    },
    data () {
        let self = (window.x = this)
        return {
            sport_id: 1,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>